import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

function scrollToHash(hash: string) {
  const id = decodeURIComponent(hash.replace(/^#/, ''))
  if (!id) return false

  const el = document.getElementById(id)
  if (!el) return false

  el.scrollIntoView({ block: 'start' })
  return true
}

export function ScrollManager() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    // For normal page navigation, always start at the top.
    if (!hash) window.scrollTo({ top: 0, left: 0 })
  }, [pathname, hash])

  useEffect(() => {
    if (!hash) return

    let cancelled = false
    let t: number | undefined

    const tryScroll = (attempt: number) => {
      if (cancelled) return
      if (scrollToHash(hash)) return

      // Section might not be in the DOM yet (lazy routes / heavy renders).
      if (attempt < 20) {
        t = window.setTimeout(() => tryScroll(attempt + 1), 50)
      }
    }

    // Defer to allow route element to mount.
    requestAnimationFrame(() => tryScroll(0))

    return () => {
      cancelled = true
      if (t) window.clearTimeout(t)
    }
  }, [pathname, hash])

  return null
}

